// extracted by mini-css-extract-plugin
export default {"burger_div":"NavigationBurger_burger_div__excGL","burger_div_clicked":"NavigationBurger_burger_div_clicked__8xpbs","background_div":"NavigationBurger_background_div__RcDYy"};